export const brandedString = (input: string) => {
  if (!input) return input
  return input.replaceAll(/\[:brand:\]/g, import.meta.env.PUBLIC_BRAND || '')
}
